import React from "react";
function footer() {
  return (
    <footer className="bg-slate-950  text-white py-6" data-aos="fade-up">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="text-center md:text-left mb-4 md:mb-0">
          <p className="text-lg font-semibold"> MBR Legal Associates</p>
          <p className="text-sm">© 2024 All Rights Reserved</p>
        </div>

        {/* Contact Information */}
        <div className="flex flex-col items-center md:items-start mb-4 md:mb-0 text-center md:text-left">
          <p className="text-sm">Address   : MBR Legal Associates</p>
          <p className="text-sm">State   : Telangana</p>
          <p className='text-sm'>Location   :  <a
            href="https://g.co/kgs/3zgdoZi"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-orange-500 hover:text-orange-300 mt-2"
          >
            Visit on Google Maps
          </a> </p>

        </div>
        <div>
          <p className="text-sm">Contact us : 9014526049 </p>
          <p className="text-sm"> Email Address  :  tharigoppularakesh93@gmail.com</p>
          
        </div>
      </div>

      {/* Developer Link */}
      <div className="text-center mt-4">
        <p className="text-sm">
          Developed by <a href="https://www.linkedin.com/in/dasi-joseph-211ab6264/" className="text-orange-500 hover:text-orange-300" target="_blank" rel="noopener noreferrer">Joseph.Dev</a>
        </p>
      </div>
    </footer>
  )
}
export default footer;